module.exports = "button.btn-quote-dismiss{min-width:200px}\n"